import { render, staticRenderFns } from "./bomDialog.vue?vue&type=template&id=333527d6&scoped=true"
import script from "./bomDialog.vue?vue&type=script&lang=js"
export * from "./bomDialog.vue?vue&type=script&lang=js"
import style0 from "./bomDialog.vue?vue&type=style&index=0&id=333527d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333527d6",
  null
  
)

export default component.exports